import React, { useEffect, useState } from 'react'
import { groupBy } from 'lodash'
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import Form from '../../../common/Form';
import { useSelector } from 'react-redux';
import FormTable from '../../../common/Form/Table';
import Input from '../../../common/Form/Input';
import Select from '../../../common/Form/Select';
import { createProjectTemplate, createWorkflow, editProjectChecklist, getProjectChecklist } from '../../../actions/project';
import { getExecutionStepsFields, removeExecutionStepFieldsFromStore } from '../../../actions/ticketExecution';
import { v4 as uuidv4 } from 'uuid';
import { actualValueForDropdown } from '../../../utils/common';
import { Controller } from 'react-hook-form';
import RenderMilestones from '../../Ticket/components/RenderMileStones';

const arrayName = 'signOffCheckList';
const formName = "checklistFrom";
const newCreatedStepsId = 'new_created_step_id';

const inputTypeOptions = [
    { label: 'Text', value: 'TEXT' },
    { label: 'Select', value: 'SELECT' },
    { label: 'Multi Select', value: 'MULTI_SELECT' },
    { label: 'File', value: 'FILE' },
];

export default function EditChecklist({ project }) {

    const { formButtonLoading } = useSelector((state) => state.loading);
    const { executionStepFields } = useSelector((state) => state.tickets);
    const dispatch = useDispatch();
    const [disabled, setDisabled] = useState(true)
    const [deletedIds, setDeletedIds] = useState([]);
    const [selectedMilestones, setSelectedMilestones] = useState('');
    const [optionInputs, setOptionInputs] = useState({});

    const projectChecklistdata = useSelector((state) => state.project?.projectChecklistdata)
    console.log('projectChecklistData:', projectChecklistdata)
    console.log('project.milestones:', project.milestones)
    console.log('selectedMilestones:', selectedMilestones)
    console.log('projectChecklistdata for RenderMilestones:', projectChecklistdata || [])

    useEffect(() => {
        if (projectChecklistdata && projectChecklistdata.length > 0) {
            setSelectedMilestones(projectChecklistdata[0].id);
        }
    }, [projectChecklistdata]);

    const defaultValues = {
        [arrayName]: [{
            id: `${Math.random()}`,
            isCreated: true,
            step_id: newCreatedStepsId,
            title: '',
            order: 1,
            is_required: true,
            is_file_required: false,
            input_type: inputTypeOptions[0],
            task_type: 'USER_DEFINED',
            options: [],
            is_ocr_required: false,
            visibility_conditions: [],
            is_repeater: false,
            spawn_tasks: null,
            group_label: null,
            cta: [],
            post_cta: [],
            metadata: {}
        }]
    };

    const methods = useForm({ defaultValues, mode: 'all' });
    const { watch, setValue } = methods

    useEffect(() => {
        dispatch(getProjectChecklist({ projectId: project.id }));
    }, [dispatch, project.id])


    useEffect(() => {
        if (projectChecklistdata && Array.isArray(projectChecklistdata) && projectChecklistdata.length > 0) {
            // Find the selected milestone and get its tasks
            const selectedMilestoneData = projectChecklistdata.find(milestone => milestone.id === selectedMilestones);

            const tasks = selectedMilestoneData?.tasks || [];

            if (Array.isArray(tasks) && tasks.length > 0) {
                const formattedTasks = tasks.map((task) => {

                    const inputTypeOption = inputTypeOptions.find(option => option.value === task.input_type) || inputTypeOptions[0];

                    return {
                        id: task.id,
                        title: task.title,
                        order: task.order,
                        project_milestone_id: task.project_milestone_id,
                        project_id: task.project_id,
                        is_required: task.is_required,
                        is_file_required: task.is_file_required,
                        input_type: inputTypeOption,
                        task_type: task.task_type,
                        options: task.options || [],
                        is_ocr_required: task.is_ocr_required,
                        visibility_conditions: task.visibility_conditions || [],
                        is_repeater: task.is_repeater,
                        spawn_tasks: task.spawn_tasks,
                        group_label: task.group_label,
                        cta: task.cta || [],
                        post_cta: task.post_cta || [],
                        metadata: task.metadata || {},
                        existing: true,
                        step_id: newCreatedStepsId
                    };
                });
                setValue(arrayName, formattedTasks);
            } else {
                setValue(arrayName, [{
                    id: `${Math.random()}`,
                    isCreated: true,
                    step_id: newCreatedStepsId,
                    title: '',
                    order: 1,
                    is_required: true,
                    is_file_required: false,
                    input_type: inputTypeOptions[0],
                    task_type: 'USER_DEFINED',
                    options: [],
                    is_ocr_required: false,
                    visibility_conditions: [],
                    is_repeater: false,
                    spawn_tasks: null,
                    group_label: null,
                    cta: [],
                    post_cta: [],
                    metadata: {}
                }]);
            }
        } else if (executionStepFields && Array.isArray(executionStepFields.single)) {
            let steps = executionStepFields.single.map((item) => {
                // Find the matching input type option for the Select component
                const inputTypeOption = inputTypeOptions.find(option => option.value === item.input_type) || inputTypeOptions[0];

                return {
                    id: item.step_fields_relationship_id,
                    title: item.field_title,
                    ...item,
                    input_type: inputTypeOption,
                    existing: true
                }
            })
            setValue(arrayName, steps);
        } else {
            setValue(arrayName, [{
                id: `${Math.random()}`,
                isCreated: true,
                step_id: newCreatedStepsId,
                title: '',
                order: 1,
                is_required: true,
                is_file_required: false,
                input_type: inputTypeOptions[0],
                task_type: 'USER_DEFINED',
                options: [],
                is_ocr_required: false,
                visibility_conditions: [],
                is_repeater: false,
                spawn_tasks: null,
                group_label: null,
                cta: [],
                post_cta: [],
                metadata: {}
            }]);
        }
    }, [projectChecklistdata, executionStepFields, setValue, selectedMilestones])

    const onSubmit = (formValues) => {
        const tasks = formValues[arrayName] || [];

        const nonDeletedTasks = tasks.filter(task => !task.isDeleted);
        const deletedTasks = tasks.filter(task => task.isDeleted);

        const orderedNonDeletedTasks = nonDeletedTasks.map((task, index) => ({
            ...task,
            order: index + 1
        }));

        // Keep deleted tasks with their original order (will be marked as deleted anyway)
        const orderedDeletedTasks = deletedTasks.map(task => ({
            ...task,
            order: task.order || -1
        }));

        const orderedTasks = [...orderedNonDeletedTasks, ...orderedDeletedTasks];

        const transformedTasks = orderedTasks.map((task, index) => {

            let formattedOptions = task.options;
            if (task.input_type && (task.input_type.value === 'MULTI_SELECT' || task.input_type.value === 'SELECT')) {
                formattedOptions = (Array.isArray(task.options) ? task.options : []).map(opt => {
                    if (typeof opt === 'string') {
                        return { label: opt, value: opt };
                    } else if (typeof opt === 'object' && opt !== null && 'label' in opt && 'value' in opt) {

                        return { label: opt.label, value: opt.value };
                    } else {
                        return { label: String(opt), value: String(opt) };
                    }
                });
            }


            if (task.isDeleted) {
                return {
                    id: task.id,
                    order: task.order,
                    title: task.title,
                    project_milestone_id: task.project_milestone_id,
                    project_id: project.id,
                    is_required: task.is_required,
                    is_file_required: task.is_file_required,
                    input_type: actualValueForDropdown(task.input_type),
                    task_type: task.task_type || 'USER_DEFINED',
                    options: formattedOptions || [],
                    is_ocr_required: task.is_ocr_required || false,
                    visibility_conditions: task.visibility_conditions || [],
                    is_repeater: task.is_repeater || false,
                    spawn_tasks: task.spawn_tasks || null,
                    group_label: task.group_label || null,
                    cta: task.cta || [],
                    post_cta: task.post_cta || [],
                    metadata: task.metadata || {},
                    isDeleted: true
                };
            }


            if (task.isCreated) {
                return {
                    order: task.order,
                    title: task.title,
                    project_milestone_id: task.project_milestone_id,
                    project_id: project.id,
                    is_required: task.is_required,
                    is_file_required: task.is_file_required,
                    input_type: actualValueForDropdown(task.input_type),
                    task_type: task.task_type || 'USER_DEFINED',
                    options: formattedOptions || [],
                    is_ocr_required: task.is_ocr_required || false,
                    visibility_conditions: task.visibility_conditions || [],
                    is_repeater: task.is_repeater || false,
                    spawn_tasks: task.spawn_tasks || null,
                    group_label: task.group_label || null,
                    cta: task.cta || [],
                    post_cta: task.post_cta || [],
                    metadata: task.metadata || {}
                };
            }


            return {
                id: task.id,
                order: task.order,
                title: task.title,
                project_milestone_id: task.project_milestone_id,
                project_id: project.id,
                is_required: task.is_required,
                is_file_required: task.is_file_required,
                input_type: actualValueForDropdown(task.input_type),
                task_type: task.task_type || 'USER_DEFINED',
                options: formattedOptions || [],
                is_ocr_required: task.is_ocr_required || false,
                visibility_conditions: task.visibility_conditions || [],
                is_repeater: task.is_repeater || false,
                spawn_tasks: task.spawn_tasks || null,
                group_label: task.group_label || null,
                cta: task.cta || [],
                post_cta: task.post_cta || [],
                metadata: task.metadata || {}
            };
        });

        const checklistId = selectedMilestones || projectChecklistdata?.[0]?.id || 'default';

        const payload = {
            projectId: project.id,
            checklistId: checklistId,
            checklist: transformedTasks,
            formName: formName
        };


        dispatch(editProjectChecklist(payload));
    };

    useEffect(() => {
        let flag = false;
        const { unsubscribe } = watch((values) => {
            let fields = values?.[arrayName];
            if (!fields || fields.length === 0) {
                flag = false
            }
            else if (Array.isArray(fields)) {
                flag = fields.every((item) => {
                    return item && item.title && item.title.length > 0
                });
            }
            setDisabled(!flag)
        });
        return () => unsubscribe();
    }, [watch]);



    const schema = {
        table: [
            {
                head: {
                    thClassName: `pl-2 w-1/4`,
                    headName: 'Task Title',
                    required: true,
                },
                body: {
                    bodyClassName: `pl-1 w-1/4 `,
                    render: (_, { rowIndex }) => (
                        <div className='text'>
                            <Input
                                name={`${arrayName}[${rowIndex}].title`}
                                type='text'
                                required
                                placeholder='Task title'
                                inputClassName={`text-font12 bg-sky-500/20 px-2 py-1 italic rounded-md text-black truncate w-96 font-normal text-font09 md:text-font11 block w-full focus:ring-0 px-4 border-2 border-scogoprimary`}
                                maxLength={50}
                            />
                        </div>
                    ),
                },
            },
            {
                head: {
                    thClassName: `w-1/4`,
                    headName: 'Input Type',
                },
                body: {
                    bodyClassName: `w-1/4 pl-2`,
                    render: (item, { rowIndex }) => {
                        const inputType = methods.watch(`${arrayName}[${rowIndex}].input_type`);

                        return (
                            <div className="space-y-2">
                                <Select
                                    name={`${arrayName}[${rowIndex}].input_type`}
                                    options={inputTypeOptions}
                                    className="w-full text-sm bg-white rounded-lg px-2 py-1 focus:border-scogoprimary focus:ring-2 focus:ring-scogoprimary/20 transition-all duration-200 hover:border-gray-400"
                                    placeholder="Select type"
                                />

                            </div>
                        );
                    },
                },
            },
            {
                head: {
                    thClassName: `w-1/4`,
                    headName: 'Options',
                },
                body: {
                    bodyClassName: `w-1/4 pl-2`,
                    render: (item, { rowIndex }) => {
                        const inputType = methods.watch(`${arrayName}[${rowIndex}].input_type`);
                        const options = methods.watch(`${arrayName}[${rowIndex}].options`) || [];

                        // Only show for MULTI_SELECT
                        if (inputType?.value !== 'MULTI_SELECT' && inputType?.value !== 'SELECT') return null;

                        const currentOptionInput = optionInputs[rowIndex] || '';

                        const handleAddOption = () => {
                            if (currentOptionInput.trim() && !options.includes(currentOptionInput.trim())) {
                                const newOptions = [...options, currentOptionInput.trim()];
                                methods.setValue(`${arrayName}[${rowIndex}].options`, newOptions);
                                setOptionInputs(prev => ({ ...prev, [rowIndex]: '' }));
                            }
                        };

                        const handleRemoveOption = (removeIdx) => {
                            const newOptions = options.filter((_, idx) => idx !== removeIdx);
                            methods.setValue(`${arrayName}[${rowIndex}].options`, newOptions);
                        };

                        return (
                            <div>
                                <div className="flex flex-wrap gap-2 mb-3">
                                    {options.map((opt, idx) => {
                                        // Support both string and {label, value} object
                                        const display = typeof opt === 'string' ? opt : (opt.label || opt.value || '');
                                        return (
                                            <span
                                                key={idx}
                                                className="bg-blue-100 text-blue-900 px-3 py-1 rounded-full flex items-center shadow-sm"
                                                style={{ fontSize: '0.95rem', fontWeight: 500 }}
                                            >
                                                {display}
                                                <button
                                                    type="button"
                                                    className="ml-2 w-5 h-5 flex items-center justify-center rounded-full hover:bg-red-100 transition-colors"
                                                    style={{ marginLeft: 8 }}
                                                    onClick={() => handleRemoveOption(idx)}
                                                    tabIndex={-1}
                                                    aria-label={`Remove ${display}`}
                                                >
                                                    <span className="text-red-500 text-lg font-bold leading-none">&times;</span>
                                                </button>
                                            </span>
                                        );
                                    })}
                                </div>
                                <div className="flex gap-2">
                                    <input
                                        type="text"
                                        value={currentOptionInput}
                                        onChange={e => setOptionInputs(prev => ({ ...prev, [rowIndex]: e.target.value }))}
                                        className="border border-gray-300 focus:border-blue-400 focus:ring-2 focus:ring-blue-100 px-3 py-1 rounded-md transition-all outline-none"
                                        placeholder="Add option"
                                        onKeyDown={e => {
                                            if (e.key === 'Enter') {
                                                e.preventDefault();
                                                handleAddOption();
                                            }
                                        }}
                                        style={{ minWidth: 0, flex: 1 }}
                                    />
                                    <button
                                        type="button"
                                        onClick={handleAddOption}
                                        className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-1 rounded-md font-medium transition-colors"
                                    >
                                        Add
                                    </button>
                                </div>
                            </div>
                        );
                    },
                },
            },
            {
                head: {
                    thClassName: `w-24`,
                    headName: 'Required',
                },
                body: {
                    bodyClassName: `w-24`,
                    render: (_, { rowIndex }) => (
                        <div className="flex items-start justify-center h-full gap-2">
                            <label className="flex items-start cursor-pointer select-none">
                                <input
                                    type="checkbox"
                                    name={`${arrayName}[${rowIndex}].is_required`}
                                    className="w-5 h-5 accent-scogoprimary rounded border-gray-300 focus:ring-2 focus:ring-scogoprimary cursor-pointer transition-colors duration-150 hover:border-scogoorange hover:shadow-md"
                                    {...methods.register(`${arrayName}[${rowIndex}].is_required`)}
                                />
                            </label>
                        </div>
                    ),
                },
            },

            {
                head: {
                    thClassName: `w-24`,
                    headName: 'Delete',
                },
                body: {
                    bodyClassName: `w-24 pl-2`,
                    render: (item, { rowIndex, remove }) => (
                        <span
                            onClick={e => {
                                e.preventDefault();
                                if (!item.isCreated) {
                                    setDeletedIds(prevState => [...prevState, item.id]);
                                }
                                remove(rowIndex);
                            }}
                            className={`material-icons text-scogoToastDangerIcon cursor-pointer hover:text-scogoorange`}
                        >
                            delete
                        </span>
                    ),
                },
            },
        ],
    };

    return (
        <div className='' >
            <Form
                className='w-full'
                onSubmit={onSubmit}
                buttonPostion={'justify-end'}
                isLoading={formButtonLoading[formName]}
                submitButtonText='Submit'
                showSubmit
                isSubmitDisabled={disabled}
                submitContainerClassName='flex gap-2 justify-end py-4 px-4 sticky bottom-0 bg-white border-t border-gray-200 z-10 flex-wrap sm:flex-nowrap'
                methods={methods}
                showCancelButton={false}
            >
                <div className="edit-checklist-formtable-unique pb-20" style={{ padding: '1.25rem' }}>
                    <RenderMilestones
                        milestones={projectChecklistdata || []}
                        selectedMilestones={selectedMilestones}
                        setSelectedMilestones={setSelectedMilestones}
                    />

                    <h3 className="text-lg font-semibold text-gray-800 mb-4">Project Tasks</h3>
                    <FormTable isLoading={false} schema={schema} name={arrayName} allowAdd addButtonClassName='my-4 text-font12 py-1' tableBodyStyle={{ maxHeight: "20rem", overflow: "auto" }} rowGenerator={() => ({
                        id: `${Math.random()}`,
                        title: '',
                        order: 1,
                        is_required: true,
                        is_file_required: false,
                        input_type: inputTypeOptions[0],
                        task_type: 'USER_DEFINED',
                        options: [],
                        is_ocr_required: false,
                        visibility_conditions: [],
                        is_repeater: false,
                        spawn_tasks: null,
                        group_label: null,
                        cta: [],
                        post_cta: [],
                        metadata: {},
                        isCreated: true,
                        step_id: newCreatedStepsId
                    })} />

                    <Input name={"name"} type='text' placeholder='Upload SignOff Images with Sign and Stamp'
                        readOnly={true}
                        inputClassName={` text-font12 bg-sky-500/20 italic px-2 py-1 rounded-md text-black truncate w-96 font-normal text-font09 md:text-font11 block w-full focus:ring-0 px-4 cursor-not-allowed `}
                    />
                </div>

            </Form>
        </div>
    )
};

const transformChecklistData = ({ list, projectId }) => {
    const groupList = groupBy(list, 'step_id');
    const stepData = Object.entries(groupList).map(([key, value]) => {
        let step = !isNaN(key) && parseInt(key, 10) > 0 ? parseInt(key, 10) : key;
        if (key === newCreatedStepsId) step = uuidv4();
        return {
            step,
            repeater: false,
            fields: value.map((item, index) => {
                return {
                    "id": item.id || item.step_fields_relationship_id,
                    "inputId": 12,
                    "repeater": item.is_repeater || false,
                    "title": item?.title,
                    "serial_order": item.order || index + 1,
                    "is_field_required": item.is_required,
                    "is_file_required": item.is_file_required,
                    "is_geo_coordinates": false,
                    "is_checklist": true,
                    "input_type": actualValueForDropdown(item.input_type),
                    "task_type": item.task_type,
                    "options": item.options,
                    "is_ocr_required": item.is_ocr_required,
                    "visibility_conditions": item.visibility_conditions,
                    "group_label": item.group_label,
                    "cta": item.cta,
                    "post_cta": item.post_cta,
                    "metadata": item.metadata,
                    existing: item.existing,
                    isCreated: item.isCreated,
                    isDeleted: item.isDeleted,
                }
            })
        }
    })
    return {
        existing: true,
        projectId,
        stepData
    }
}
